var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.499 2.996v1.801a.557.557 0 0 0 .5.6h4.002a.557.557 0 0 0 .5-.6v-1.8M10 18.003H14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.002 21.004H7.998a2 2 0 0 1-2-2.001V4.997a2 2 0 0 1 2-2h8.004a2 2 0 0 1 2 2v14.006a2 2 0 0 1-2 2",
    clipRule: "evenodd"
  })));
};
export { SvgPhone as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMzlhNThlOWUyOTk1OGY4MzNlY2NjMTFlYTdiNjhlNDQuc3ZnIjs=";